import React, { useContext } from "react";

import styled from "@emotion/styled";

import { DataContext } from "../../../../../../providers/PelletsCheckoutDataProvider";
import FormRow from "../../../../../shared/forms/FormRow";
import Input from "../../../../../shared/forms/NewInput";
import Margin from "../../../../../shared/Margin";

const StyledP = styled.p`
    font-size: small;
`;
const PromotionCode = () => {
    const dataContext = useContext(DataContext);

    const { promotionCode } = dataContext.data;
    const { setPromotionCode, addFormError, clearFormError, hasFormErrorAt } =
        dataContext.actions;

    return (
        <>
            <Margin
                Component={FormRow}
                top="50"
                bigLabel
                label="Aktionscode:"
                field={
                    <Input
                        placeholder="Aktionscode"
                        name="promotion_code"
                        onChange={(event) =>
                            setPromotionCode(event.target.value)
                        }
                        value={promotionCode}
                        validation="promotion-code"
                        forceError={hasFormErrorAt("promotion_code")}
                        onError={() => addFormError("promotion_code")}
                        onErrorSolved={() => clearFormError("promotion_code")}
                    />
                }
            />
            <StyledP>
                Bitte beachte: der Rabatt wird erst auf der Rechnung abgezogen.
            </StyledP>
        </>
    );
};

export default PromotionCode;
